/*
  Incl / Excl BTW toggle - ozelwerkkleding.nl
  - Product page: toggle under the price (as before).
  - 02-10-2026: extra toggle in the desktop header, left of "Nederland | EUR" (web view only).
  - The choice is remembered (localStorage) and applied to ALL product prices on every page:
    product page, collection grids, search, homepage product sliders and the branche-kiezer.
  - Cart, cart drawer and checkout always stay incl. BTW (that is what the customer pays).
*/
(function () {
  var BTW_RATE = 1.21;
  var STORE_KEY = 'ozel-btw-mode';
  var PRICE_SELECTOR = [
    '.price',
    '[class*="collection-product-price-"]',
    '[class*="collection-compare-price-"]',
    '.obk__price'
  ].join(',');
  var SKIP_SELECTOR = [
    'cart-drawer', 'cart-drawer-items', 'cart-items', 'cart-notification', '.cart-drawer', '#CartDrawer',
    '.cart-notification', '.cart__footer', '.totals', '.cart-item', 'form[action*="/cart"]',
    '.volume-pricing-note', 'price-per-item', 'volume-pricing', '.announcement-bar', '[data-btw-toggle]',
    'script', 'style', 'noscript'
  ].join(',');

  var mode = 'incl';
  try { if (localStorage.getItem(STORE_KEY) === 'excl') mode = 'excl'; } catch (e) {}

  function parsePrice(text) {
    var m = text.match(/\d[\d.,]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var lastSep = null;
    var lastSepIndex = -1;
    for (var i = raw.length - 1; i >= 0; i--) {
      if (raw.charAt(i) === '.' || raw.charAt(i) === ',') {
        lastSep = raw.charAt(i);
        lastSepIndex = i;
        break;
      }
    }
    var integerPart, decimalPart, decimalSep;
    if (lastSep && raw.length - lastSepIndex - 1 === 2) {
      decimalSep = lastSep;
      integerPart = raw.slice(0, lastSepIndex).replace(/[.,]/g, '');
      decimalPart = raw.slice(lastSepIndex + 1);
    } else {
      decimalSep = ',';
      integerPart = raw.replace(/[.,]/g, '');
      decimalPart = '00';
    }
    var value = parseFloat(integerPart + '.' + decimalPart);
    if (isNaN(value)) return null;
    return { value: value, decimalSep: decimalSep, matchIndex: m.index, matchText: m[0] };
  }

  function formatValue(value, decimalSep) {
    var rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    var parts = rounded.toFixed(2).split('.');
    var thousandsSep = decimalSep === ',' ? '.' : ',';
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + decimalSep + parts[1];
  }

  function exclText(original) {
    var parsed = parsePrice(original);
    if (!parsed) return original;
    var newRaw = formatValue(parsed.value / BTW_RATE, parsed.decimalSep);
    return original.slice(0, parsed.matchIndex) + newRaw + original.slice(parsed.matchIndex + parsed.matchText.length);
  }

  /* ---------- convert one text node (remembers its original incl. text) ---------- */
  function convertTextNode(node, m) {
    var text = node.data;
    if (!/\d/.test(text)) return;
    if (node.__btwSet !== undefined && text === node.__btwSet) {
      // text is what we wrote last time -> just (re)apply current mode
    } else {
      node.__btwIncl = text; // new or changed by the theme (e.g. variant change) -> this is the incl. price
    }
    var wanted = (m || mode) === 'excl' ? exclText(node.__btwIncl) : node.__btwIncl;
    node.__btwSet = wanted;
    if (node.data !== wanted) node.data = wanted;
  }

  function convertContainer(el) {
    if (!el || el.closest(SKIP_SELECTOR)) return;
    var cm = (window.matchMedia('(max-width: 989px)').matches && !el.closest('product-info')) ? 'incl' : mode; /* 11-10-2026: mobile always incl. BTW outside the product page */ var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (n.parentElement && n.parentElement.closest(SKIP_SELECTOR)) continue;
      convertTextNode(n, cm);
    }
  }

  function convertAll(root) {
    root = root || document;
    if (root.nodeType === 1 && root.matches && root.matches(PRICE_SELECTOR)) convertContainer(root);
    if (root.querySelectorAll) root.querySelectorAll(PRICE_SELECTOR).forEach(convertContainer);
  }

  /* ---------- toggles (header + product page) ---------- */
  function updateToggles() {
    document.querySelectorAll('[data-btw-toggle] [data-btw-mode]').forEach(function (btn) {
      var on = btn.getAttribute('data-btw-mode') === mode;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function setMode(m) {
    mode = m === 'excl' ? 'excl' : 'incl';
    try { localStorage.setItem(STORE_KEY, mode); } catch (e) {}
    convertAll(document);
    updateToggles();
  }

  function buildToggle(extraClass) {
    var toggle = document.createElement('div');
    toggle.className = 'btw-toggle' + (extraClass ? ' ' + extraClass : '');
    toggle.setAttribute('data-btw-toggle', '');
    toggle.setAttribute('role', 'group');
    toggle.setAttribute('aria-label', 'Prijzen incl. of excl. BTW');
    [['incl', 'Incl BTW'], ['excl', 'Excl BTW']].forEach(function (pair) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'btw-toggle__btn';
      b.setAttribute('data-btw-mode', pair[0]);
      b.textContent = pair[1];
      b.addEventListener('click', function () { setMode(pair[0]); });
      toggle.appendChild(b);
    });
    return toggle;
  }

  function addHeaderToggle() {
    var wrap = document.querySelector('.desktop-localization-wrapper');
    if (!wrap || wrap.querySelector('[data-btw-toggle]')) return;
    wrap.insertBefore(buildToggle('btw-toggle--header'), wrap.firstChild);
  }

  function addProductToggle() {
    var price = document.querySelector('product-info [id^="price-"]');
    if (!price) return;
    if (price.closest('.volume-pricing-note, price-per-item, volume-pricing')) return;
    var next = price.nextElementSibling;
    if (next && next.hasAttribute && next.hasAttribute('data-btw-toggle')) return;
    price.insertAdjacentElement('afterend', buildToggle());
    var taxNotice = document.querySelector('product-info .product__tax');
    if (taxNotice) taxNotice.style.display = 'none';
  }

  /* ---------- keep up with prices the theme adds or changes later ---------- */
  var scheduled = false;
  var pending = [];
  function schedule(node) {
    pending.push(node);
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(function () {
      scheduled = false;
      var list = pending; pending = [];
      addProductToggle();
      addHeaderToggle();
      list.forEach(function (n) {
        var el = n.nodeType === 3 ? n.parentElement : n;
        if (!el || !el.isConnected) return;
        var priceEl = el.closest ? el.closest(PRICE_SELECTOR) : null;
        if (priceEl) convertContainer(priceEl);
        else convertAll(el);
      });
      updateToggles();
    });
  }

  function init() {
    addHeaderToggle();
    addProductToggle();
    convertAll(document);
    updateToggles();
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') {
          if (r.target.data !== r.target.__btwSet) schedule(r.target);
        } else {
          r.addedNodes.forEach(function (n) { if (n.nodeType === 1 || n.nodeType === 3) schedule(n); });
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pageshow', function () { convertAll(document); updateToggles(); }); try { window.matchMedia('(max-width: 989px)').addEventListener('change', function () { convertAll(document); }); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
